// extracted by mini-css-extract-plugin
module.exports = {"rsvp":"styles_rsvp__cE8HJ","spacer":"styles_spacer__2Yz2_"};